import {TokenExchangeRequestRestDto} from "@/api/pharma-auth-admin/models";
import {TokenExchangeTypeEnum} from "@/api/enums/token-exchange-type-enum";

export class TokenExchangeRequestRestDtoModel implements TokenExchangeRequestRestDto {
    exchange_type_code: TokenExchangeTypeEnum;
    customer_codes: string[];

    constructor(exchange_type_code: TokenExchangeTypeEnum, customer_codes: string[]) {
        this.exchange_type_code = exchange_type_code;
        this.customer_codes = customer_codes;
    }

    public static createWithDefaults(): TokenExchangeRequestRestDtoModel {
        return new this(TokenExchangeTypeEnum.RESTRICTED_ADMIN, []);
    }

    public static cloneFrom(source: TokenExchangeRequestRestDto): TokenExchangeRequestRestDtoModel {
        return new this(
            source.exchange_type_code,
            [...source.customer_codes]
        );
    }
}
